import type { FunctionComponent } from 'react';
import Image from '@atlaskit/image';
import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import { useMcpContext } from '../McpContextProvider';

import AtlassianIllustration from '#assets/illustrations/mcp/atlassian.svg';
import TrelloIllustration from '#assets/illustrations/mcp/trello.svg';

const styles = cssMap({
  image: {
    width: '100%',
    marginTop: token('space.1000'),
  },
});

/** Illustration for the "What is an MCP server?" info card.
 *  Shows the Trello illustration for Trello-only flows, and the
 *  Atlassian illustration otherwise.
 */
const ProductIconsIllustration: FunctionComponent = () => {
  const { scopeClassification } = useMcpContext();
  const isTrelloOnly =
    scopeClassification.hasTrello && !scopeClassification.hasAtlassian;

  return (
    <Image
      css={styles.image}
      src={isTrelloOnly ? TrelloIllustration : AtlassianIllustration}
    />
  );
};

export default ProductIconsIllustration;
